export interface NavigationOption {
    sref: string;
    label: string;
}

export type NavigationOptions = Array<NavigationOption>;

export function getSrefWithPolicyIndex(stateName: string, policyIndex: RoutePolicyIndex) {
    // return something like overview(policyIndex: 1)
    return `${stateName}({policyIndex: ${policyIndex}})`;
}

export type StateName =
    | 'overview'
    | 'coverage'
    | 'checklist'
    | 'payments'
    | 'smart-home'
    | 'messages'
    | 'get-more'
    | 'policy-claims'
    | 'claims'
    | 'policies'
    | 'logout'
    | 'login'
    | 'error';

export const OVERVIEW_STATE: StateName = 'overview';
export const COVERAGE_STATE: StateName = 'coverage';
export const CHECKLIST_STATE: StateName = 'checklist';
export const PAYMENTS_STATE: StateName = 'payments';
export const SMART_HOME_STATE: StateName = 'smart-home';
export const MESSAGES_STATE: StateName = 'messages';
export const GET_MORE_STATE: StateName = 'get-more';
export const POLICY_CLAIMS_STATE: StateName = 'policy-claims';
export const CLAIMS_STATE: StateName = 'claims';
export const POLICIES_STATE: StateName = 'policies';
export const LOGOUT_STATE: StateName = 'logout';
export const LOGIN_STATE: StateName = 'login';
export const ERROR_STATE: StateName = 'error';

export function getNavigationStates(policyIndex: RoutePolicyIndex): NavigationOptions {
    return [
        {
            sref: getOverviewSref(policyIndex),
            label: 'Overview'
        },
        {
            sref: getCoverageSref(policyIndex),
            label: 'Coverage'
        },
        {
            sref: getChecklistSref(policyIndex),
            label: 'Checklist'
        },
        {
            sref: getPaymentsSref(policyIndex),
            label: 'Payments'
        },
        {
            sref: getGetMoreSref(policyIndex),
            label: 'Get More'
        },
        {
            sref: getClaimsSref(policyIndex),
            label: 'Claims'
        }
    ];
}

export function getNavigationStatesWithSmartHome(policyIndex: RoutePolicyIndex): NavigationOptions {
    return [
        {
            sref: getOverviewSref(policyIndex),
            label: 'Overview'
        },
        {
            sref: getCoverageSref(policyIndex),
            label: 'Coverage'
        },
        {
            sref: getChecklistSref(policyIndex),
            label: 'Checklist'
        },
        {
            sref: getPaymentsSref(policyIndex),
            label: 'Payments'
        },
        {
            sref: getSmartHomeSref(policyIndex),
            label: 'Smart Home'
        },
        {
            sref: getGetMoreSref(policyIndex),
            label: 'Get More'
        },
        {
            sref: getClaimsSref(policyIndex),
            label: 'Claims'
        }
    ];
}

export function getOverviewSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(OVERVIEW_STATE, policyIndex);
}

export function getCoverageSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(COVERAGE_STATE, policyIndex);
}

export function getChecklistSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(CHECKLIST_STATE, policyIndex);
}

export function getPaymentsSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(PAYMENTS_STATE, policyIndex);
}

export function getPaymentsSrefWithPayNow(policyIndex: RoutePolicyIndex) {
    return `${PAYMENTS_STATE}({policyIndex: ${policyIndex}, showPayNow: true})`;
}

export function getSmartHomeSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(SMART_HOME_STATE, policyIndex);
}

export function getMessagesSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(MESSAGES_STATE, policyIndex);
}

export function getGetMoreSref(policyIndex: RoutePolicyIndex) {
    return getSrefWithPolicyIndex(GET_MORE_STATE, policyIndex);
}

export function getClaimsSref(policyIndex?: RoutePolicyIndex) {
    if (typeof policyIndex !== 'undefined') {
        return getSrefWithPolicyIndex(POLICY_CLAIMS_STATE, policyIndex);
    } else {
        return CLAIMS_STATE;
    }
}

export function getPoliciesSref() {
    return POLICIES_STATE;
}

export function getLoginSref() {
    return LOGIN_STATE;
}

export function getLogoutSref() {
    return LOGOUT_STATE;
}
